var documentHeight = $(document).height(),
		windowHeight = $(window).height(),
		footerHeight = $('.wrapper--footer').height(),
		breakPointScroll = documentHeight - windowHeight - footerHeight;

setStaticPagenav();

$(window).on('scroll', setStaticPagenav);
$(window).on('resize', setStaticPagenav);
$('.js-scrollup').on('click', scrollUp);

function scrollUp() {
	$('html').velocity('scroll', {axis: '0'});
}

function setStaticPagenav() {
	documentHeight = $(document).height();
	windowHeight = $(window).height();
	breakPointScroll = documentHeight - windowHeight - footerHeight;

	if ($(window).scrollTop() >= breakPointScroll) {
		$('.js-fixed-area').addClass('now-static-area');

		if (windowHeight === documentHeight) {
			$('.js-fixed-area')
				.removeClass('now-static-area')
				.addClass('above-footer');
		} else {
			$('.js-fixed-area').removeClass('above-footer');
		}
	} else {
		$('.js-fixed-area')
			.removeClass('now-static-area')
			.removeClass('above-footer');
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/page-nav/page-nav.js
 **/